import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class EllipsisButton extends React.Component {
  constructor (props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick (e) {
    e.preventDefault();

    this.props.onClick(e);
  }

  render () {
    const { buttonClassName } = this.props;
    const className = classnames('btn', buttonClassName || 'ellipsis-button remove-click-styling');

    return (
      <button className={className} onClick={this.handleClick} onKeyPress={this.handleClick}>
        <div className="dot">&#183;&#183;&#183;</div>
      </button>
    );
  }
}


EllipsisButton.propTypes = {
  onClick: PropTypes.func,
  buttonClassName: PropTypes.string
};
